<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="i">
      <app-menu-item :item="item" :index="i"></app-menu-item>
    </template>
    <li></li>
  </ul>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import AppMenuItem from './AppMenuItem.vue';
import { useEventStore } from "@/stores/event.store";
import { useAuthStore } from "@/stores/auth.store";
import LogoutButton from '@/components/mics/LogoutButton.vue';
import { useI18n } from 'vue-i18n';


const eventStore = useEventStore();
const authStore = useAuthStore();
const { t } = useI18n();

const model = computed(() => {
  const isAdmin = authStore.isAdmin();

  const usersItem = {
    label: t('admin.sidebar.users'),
    icon: 'pi pi-fw pi-users',
    to: '/admin/users'
  };

  const masterDataItems = isAdmin
    ? [
        {
          label: t('admin.sidebar.events'),
          icon: 'pi pi-fw pi-calendar',
          to: '/admin/events'
        },
        {
          label: t('admin.sidebar.exhibitors'),
          icon: 'pi pi-fw pi-building',
          to: '/admin/exhibitors'
        },
        usersItem
      ]
    : [usersItem];

  const sections: any[] = [
    {
      label: 'Admin',
      items: [
        {
          label: t('admin.sidebar.dashboard'),
          icon: 'pi pi-home',
          to: '/',
        },
        {
          label: t('admin.sidebar.masterData'),
          icon: 'pi pi-fw pi-database',
          expanded: true,
          items: masterDataItems
        },
        ...(isAdmin
          ? [
              {
                label: t('admin.sidebar.sync'),
                icon: 'pi pi-fw pi-refresh',
                expanded: true,
                items: [
                  {
                    label: t('admin.sidebar.syncEvents'),
                    icon: 'pi pi-fw pi-sliders-h',
                    to: '/admin/sync-events'
                  },
                  {
                    label: t('admin.sidebar.syncHistory'),
                    icon: 'pi pi-fw pi-history',
                    to: '/admin/sync-history'
                  }
                ]
              }
            ]
          : [])
      ]
    }
  ];

  if (isAdmin) {
    sections.push({
      label: t('admin.sidebar.externalLinks'),
      items: [
        {
          label: 'Momentus URL Generator',
          icon: 'pi pi-fw pi-external-link',
          url: 'https://sso.ungerboeck.net/GHM/PROD/SSOExternalApps/sp/link',
          target: '_blank'
        },
      ]
    });
  }

  return sections;
});
</script>
